export default __webpack_public_path__ + "static/media/pin-black.4d1eca7e.svg";